import { render, staticRenderFns } from "./gaps-in-service.vue?vue&type=template&id=ec2ea23c"
import script from "./gaps-in-service.vue?vue&type=script&lang=js"
export * from "./gaps-in-service.vue?vue&type=script&lang=js"
import style0 from "./gaps-in-service.vue?vue&type=style&index=0&id=ec2ea23c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports